/*
 * Dropdown
 */

// LE BUT EST D'AVOIR UN MÊME COMPOSANT EN:
//  - Vue
//  - Razor (server side TagHelper)
//  - Vanilla Js

/// 1. create from JS:
//const node = builder.component('p-dropdown', { placeholer: '' }); // create like razor taghelper + attachDropdown(node)

const attachDropdown = (node) => {};

const createDropdown = (attributes) => {};

const razorDropdown = {
  selector: ".a-dropdown",
  create: createDropdown,
  attach: attachDropdown,
};

export default razorDropdown;
